const list = {
  inputName: 'Nombre y Apellido',
  inputUsername: 'Usuario',
  inputLogin: 'Iniciar sesión',
  inputCpf: 'CPF',
  inputCellphone: 'Teléfono móvil',
  inputDdd: 'DDD',
  inputEmail: 'Correo electrónico',
  inputPhoneNumber: 'Teléfono móvil',
  inputSelect: 'Seleccionar',
  inputSearchFarm: 'Buscar una granja',
  inputWriteHere: 'Escribe aquí',
  inputPassword: 'Contraseña',
  inputNewPassword: 'Nueva Contraseña',
  inputConfirmNewPassword: 'Confirmar Nueva Contraseña',
  inputPasswordHintTitle: 'La contraseña debe tener:',
  inputConfirmPasswordHintTitle: 'La contraseña no coincide con la ingresada',
  inputPasswordHint1: 'Mínimo de 6 caracteres',
  inputPasswordHint2: '1 número',
  inputPasswordHint3: '1 letra minúscula',
  inputPasswordHint4: '1 letra mayúscula',
  inputPasswordHint5: '1 carácter especial (*&$!)',
  inputPasswordHint6: 'Solo números',
  inputConfirmPassword: 'Confirmar contraseña',
  inputCode: 'Código de verificación',
  buttonActionBack: 'Regresar',
  buttonEnter: 'Ingresar',
  buttonAccess: 'Acceder',
  buttonAlter: 'Modificar',
  buttonAltering: 'Modificando',
  buttonEntering: 'Ingresando..',
  buttonAcessing: 'Accediendo..',
  buttonRegister: 'Registrar',
  buttonRegistering: 'Registrando...',
  buttonConfirm: 'Confirmar',
  buttonConfirming: 'Confirmando...',
  buttonSend: 'Enviar',
  buttonSending: 'Enviando...',
  buttonGoSelectFarm: 'Seleccionar Granja',
  buttonBack: 'Volver',
  validateRequired: 'Campo obligatorio',
  validateInvalidEmail: 'Correo electrónico no válido',
  validateInvalidUsername: 'Nombre de usuario no válido',
  validatePhoneMin: 'El teléfono debe tener DDD + 9 dígitos',
  validateMinPassword: 'La contraseña debe tener 6 dígitos numéricos',
  validatePasswordMin: 'La contraseña debe tener 6 dígitos numéricos',
  validatePasswordMax: 'La contraseña debe tener 6 dígitos numéricos',
  validatePasswordOnlyNumbers: 'La contraseña solo debe tener dígitos numéricos',
  validatePasswordOneLowercaseCharacter: 'Al menos un carácter en minúscula',
  validatePasswordOneUppercaseCharacter: 'Al menos un carácter en mayúscula',
  validatePasswordOneNumber: 'Al menos un número',
  validatePasswordOneSpecialCharacter: 'Al menos un carácter especial ej: @,$,!,%...',
  validatePasswordNotEquals: 'Las contraseñas no coinciden',
  validateCodeOnlyNumber: 'El código solo tiene números',
  validateCodeFormatInvalid: 'Formato no válido',
  loginNewPassword: '¡Debe cambiar su contraseña!',
  codeMismatchExceptionInvalidVerificationCode: 'Código de verificación no válido, inténtelo de nuevo.',
  forgotPasswordExceptionCodeSendingSuccess: 'Hemos enviado un código de verificación a su correo electrónico. Si no recibe el correo electrónico en unos minutos, revise su carpeta de spam o repita el proceso.',
  forgotPasswordExceptionContactVerifiedRequired: 'Es necesario tener correo electrónico o teléfono verificado para recuperar la contraseña.\nPor favor contacte al soporte +55 19 97144-1818',
  forgotPasswordExceptionDefaultError: 'Error al intentar recuperar la contraseña, inténtelo de nuevo.',
  forgotPasswordExceptionPasswordChangedSuccessfully: '¡Su contraseña ha sido cambiada con éxito!',
  notAuthorizedExceptionIncorrect: 'Usuario o contraseña incorrectos.',
  userExceptionLogin: 'Ocurrió un error al conectarse, inténtelo de nuevo.',
  userNotFoundExceptionNotFound: 'Usuario no encontrado',
  userNotFoundExceptionNotFoundCustomOnFarm: 'Su usuario aún no ha sido migrado al Nuevo OnFarmApp. Haga clic en el enlace a continuación para acceder al OnFarmApp en operación en su granja:',
  userNotFoundExceptionNotFoundCustomOnFarmStore: 'Su usuario aún no ha sido migrado al Nuevo OnFarmApp. Haga clic en el enlace a continuación para acceder a la tienda en operación para su granja: ',
  usernameExistsExceptionEmailAlreadyExists: 'Ya existe una cuenta con el nombre de usuario proporcionado.',
  userNotConfirmedExceptionUserIsNotConfirmed: 'Usuario no confirmado.',
  userNotFoundExceptionEmailAndPhoneNotFound: 'Es necesario registrar correo electrónico y teléfono',
  userNotFoundExceptionPhoneNotFound: 'Es necesario registrar un teléfono, contacte al soporte',
  userNotFoundExceptionEmailNotFound: 'Es necesario registrar un correo electrónico, contacte al soporte',
  loginColumnLeftTitle: '¿Es la primera vez que accede? ¡Regístrese aquí!',
  loginColumnLeftRegister: 'Registrar',
  loginTitle: 'Acceda a su cuenta',
  loginResetPassword: 'Olvidé mi contraseña',
  userApp: 'Usuario APP',
  passwordUserApp: 'Contraseña',
  registerColumnLeftTitle: '¿Ya está registrado? ¡Haga clic aquí!',
  registerColumnLeftLogin: 'Iniciar sesión',
  registerTitle: 'Regístrese',
  registerColumnRightNotify: 'Acepto recibir alertas de nuevos contenidos por correo electrónico',
  confirmSignUpWelcome: 'Bienvenido',
  confirmSignUpTitle: 'Se ha enviado un Código de Verificación al correo electrónico registrado, ingrese el código para continuar:',
  confirmSignUpResendConfirmationCode: 'Reenviar código',
  confirmSignUpCodeResentSuccessfully: 'Código enviado con éxito',
  confirmSignUpErrorResendingCode: 'Error al enviar el código, inténtelo de nuevo.',
  confirmSignUpVerifiedUser: 'Usuario verificado con éxito.',
  confirmSignUpVerifiedAlreadyUser: 'Usuario ya verificado.',
  userContactTitle: 'Por favor, ingrese su correo electrónico y su teléfono para continuar usando el sistema.',
  userContactDone: '¡Correo electrónico y teléfono registrados!',
  confirmContactTitlePhone: 'El código de verificación ha sido enviado a su teléfono móvil, por favor ingréselo a continuación.',
  confirmContactTitleEmail: 'El código de verificación ha sido enviado a su correo electrónico, por favor ingréselo a continuación.',
  confirmContactInputPhoneNumber: 'Reenviar código',
  confirmContactInputEmail: 'Código enviado con éxito',
  confirmContactErrorResendingCode: 'Error al enviar el código, inténtelo de nuevo.',
  confirmContactVerifiedUser: 'Contacto verificado con éxito.',
  newFarmTitle: 'Registre una granja ahora.',
  newUserTitle: 'Registre su usuario.',
  accessFarmWelcome: 'Bienvenido(a)',
  accessFarmTitle: 'Acceso habilitado para:',
  selectFarmConfirmation: 'Seleccione la granja para continuar: ',
  almostThere: 'Casi estamos: ',
  nowSelectFarmCategory: 'Ahora seleccione la categoría deseada: ',
  forgotPasswordTitle: 'Ingrese el nombre de usuario registrado.',
  passwordRecoveryTitle: 'Ingrese el código que enviamos a su correo electrónico y registre una nueva contraseña',
  newPasswordInputTitle: 'Ingrese la nueva contraseña que desea utilizar',
  typeReceivedNewPasswordTitle: 'Ahora indique cómo desea recibir una nueva contraseña',
  newPasswordTitle: 'Defina una nueva contraseña',
  typeReceivedPasswordEmail: 'Recibir por correo electrónico',
  typeReceivedPasswordSms: 'Recibir por SMS',
  passwordSentSuccess: 'Contraseña enviada con éxito, revise su correo electrónico/SMS',
  noPoints: 'No quiero usar puntos',
  signUpTitle: 'Ingrese sus datos de registro',
  registerError: 'Error al registrar usuario, inténtelo de nuevo.',
  labelDigiteNomeUsuario: 'Introduzca el nombre de usuario',
  labelDigiteSenha: 'Introduce la contraseña',
  labelSelecioneFazendaAvancar: 'Seleccione la granja para avanzar',
  labelBemVindo: 'Bienvenido',
  labelCarregando: 'Cargando',
};

export default list;